import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useComplianceStore from '../../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Leave Types Manage loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Leave Types Manage loader'
  )

  // We don't want to call getLeaveTypes if the leave types are already loaded - if we go straight into the manage leave types page
  // instead of going through the LeaveTypes page first, then we want to call the getLeaveTypes function
  const complianceStoreState = useComplianceStore.getState()
  const getLeaveTypes =
    complianceStoreState.leaveTypes.length === 0 &&
    complianceStoreState.getLeaveTypes()

  return defer({
    data: Promise.all([getLeaveTypes])
      .then(() => true)
      .catch((error) => {
        logger.error('Leave Types Manage Promise.all error', error)
        return false
      }),
  })
}
